import React from "react";
import FormControlled, {
  FormBehaviourProps,
  FormControlProps,
} from "../../../components/validation/FormControlled";
import IconFloatInput from "../../../components/input/IconFloatInput";
import { mailRegEx } from "../../../api/validation";

type ControlledIconFloatInputProps = FormBehaviourProps<string> &
  FormControlProps;

export default function EmailFormField(props: ControlledIconFloatInputProps) {
  return (
    <FormControlled
      {...props}
      rules={{
        pattern: mailRegEx,
        required: true,
      }}
      errorMessages={{
        pattern: "Die angegebene E-Mail Adresse ist nicht gültig",
        required: "Bitte geben Sie eine E-Mail Adresse an",
      }}
    >
      {(renderProps) => (
        <IconFloatInput label="E-Mail" icon="pi-user" {...renderProps} />
      )}
    </FormControlled>
  );
}
